import { TbChevronRight } from "react-icons/tb";
import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryTab = queryParams.get("tab");

  const isMongoId = (str) => /^[a-f\d]{24}$/i.test(str);

  const pathnames = location.pathname
    .split("/")
    .filter((x) => x && x !== "app" && x !== "dashboard" && !isMongoId(x));

  return (
    <nav className="lg:text-lg text-sm xl:pl-0 pl-12">
      <ol className="flex space-x-1 items-center">
        <li>
          <Link to="/" className="hover:underline text-[#000]">
            Home
          </Link>
        </li>
        {pathnames.map((name, index) => {
          let routeTo = `/app/${pathnames.slice(0, index + 1).join("/")}`;
          if (queryTab && name === "monitoring-unit") {
            routeTo += `?tab=${queryTab}`;
          }
          const formattedName = name
            .split("-")
            .map((word) =>
              word.toLowerCase() === "p2p"
                ? "P2P"
                : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(" ");
          const isLast = index === pathnames.length - 1;

          return (
            <li key={routeTo} className="flex items-center capitalize">
              <span className="">
                <TbChevronRight />
              </span>
              {isLast ? (
                <span className="text-[#000]">{formattedName}</span>
              ) : (
                <Link to={routeTo} className="hover:underline text-[#000]">
                  {formattedName}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
